import { EntityService } from '@/services/EntityService';
import { getArrayBuffer } from '@/helpers/httpHandler';
import { ErrorWrapper } from '@/services/util';

export class ReportsService extends EntityService {
  static get entity() {
    return 'report';
  }

  static async retrieveBusinessCustomerHabitationHistory(bCustomerId) {
    return await getArrayBuffer(
      `${this.entity}/b-customer-habitation-history/${bCustomerId}`
    );
  }

  static async getCustomerHabitationReport() {
    return await getArrayBuffer(`${this.entity}/customers-habitation`);
  }

  static async getActivityLogReport(params = {}) {
    return this.request({ auth: true })
      .get(`${this.entity}/activity-log`, { params })
      .then(() => {
        return getArrayBuffer(`${this.entity}/activity-log`, params);
      })
      .catch(error => {
        throw new ErrorWrapper(error);
      });
  }

  static async getMagazineReport() {
    return await getArrayBuffer(`${this.entity}/magazine`);
  }

  static async getCommunicationoptionsReport() {
    return await getArrayBuffer(`${this.entity}/communication-options`);
  }
}
